import { render, staticRenderFns } from "./notification-list.vue?vue&type=template&id=7528a6e4&scoped=true&"
import script from "./notification-list.vue?vue&type=script&lang=js&"
export * from "./notification-list.vue?vue&type=script&lang=js&"
import style0 from "./notification-list.vue?vue&type=style&index=0&id=7528a6e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7528a6e4",
  null
  
)

component.options.__file = "notification-list.vue"
export default component.exports